import { apiClient } from '@/services';

export const CartService = {
  addToCart({
    articleId,
    supplierArticleTag,
    quantity,
    price,
    shortDescription,
    longDescription,
    articleGroup,
    supplier,
    ean,
    wheelsetComponents,
  }) {
    return apiClient.post('/cart', {
      articleId,
      supplierArticleTag,
      quantity,
      price,
      shortDescription,
      longDescription,
      articleGroup,
      supplier,
      ean,
      wheelsetComponents,
    });
  },
  getCart() {
    return apiClient.get('/cart');
  },
  editCartQuantityById({ positionId, quantity }) {
    return apiClient.put('/cart', {
      positionId,
      quantity,
    });
  },
  getAddress() {
    return apiClient.get('/cart/get-addresses');
  },
  addAddress({ name, street, streetNumber, zip, city, country, countryCode }) {
    return apiClient.post('/cart/add-address', {
      name,
      street,
      streetNumber,
      zip,
      city,
      country,
      countryCode,
    });
  },
  changeAddress({ sourceId, addressId }) {
    return apiClient.put(`/cart/change-address/${sourceId}/${addressId}`);
  },
  deleteCartPosition(id) {
    return apiClient.delete(`/cart/position/${id}`);
  },
  clearCart() {
    return apiClient.delete('/cart');
  },
  order(payload) {
    return apiClient.post('/cart/order', payload);
  },
  getService(zipCode) {
    return apiClient.get(`/services/centers/${zipCode}`);
  },
};
